<section class="component-container">
  <h3 class="page-title">{{ currentUrl | quotationType}}</h3>

  @if (currentUrl === 'quotations') {
    <div class="custom-tabs">
      @for (type of quotationsTypes; track type) {
        <button class="tab-button" (click)="changeQuotationType(type)"
        [ngClass]="type == selectedQuotationType ? 'active' : ''">{{type | quotationType }}</button>
      }
    </div>
  }

  @if (quotations) {
    <app-common-table [data]="quotations" [columnData]="quotationsTableHeader"
    (viewRow)="viewSelectedRow($event)" (changePage)="changePage($event)" [tableFor]="currentUrl" ></app-common-table>
  }
</section>